import * as React from 'react';
import { LANGUAGE, MARKET } from '../constants/storageKeys';
import { defaultLangPerMarket } from '../constants/flags';
import moment from 'moment';

interface CountryContextValue {
    country: string;
}

const CountryContext = React.createContext<CountryContextValue | undefined>(undefined);

function getCountry(): string {
    const paramString = window.location.search;
    const params = new URLSearchParams(paramString);
    const param = params.get('country');
    const prev = window.localStorage.getItem(MARKET);

    if (param !== null) {
        window.localStorage.setItem(MARKET, param);
        return param;
    } else if (prev !== null) {
        return prev;
    } else {
        window.localStorage.setItem(MARKET, 'se');
        return 'se';
    }
}

export function CountryProvider({ children }: { children: React.ReactNode }) {
    const country = React.useMemo(() => {
        const c = getCountry();

        if (!localStorage[LANGUAGE]) {
            const defaultLang = defaultLangPerMarket[c];
            localStorage[LANGUAGE] = defaultLang;
        }
        moment.locale(localStorage[LANGUAGE]);

        return c;
    }, []);

    return (
        <CountryContext.Provider value={{ country }}>
            {children}
        </CountryContext.Provider>
    );
}

export function useCountry(): CountryContextValue {
    const ctx = React.useContext(CountryContext);
    if (!ctx) throw new Error('useCountry must be used inside CountryProvider');
    return ctx;
}
